import { Concept, Representation } from "../Types";
import {
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { EditableText } from "./EditableText";

type RepProps = {
  onEditKey?: (oldFieldId: string, newFieldId: string) => void;
  onEditValue: (fieldId: string, fieldValue: string) => void;
  onRemoveField: (fieldId: string) => void;
  fieldId: string;
  fieldValue: string;
};

export default function SingleFieldEditor(props: RepProps) {
  const {
    onEditKey,
    onEditValue,
    onRemoveField,
    fieldId,
    fieldValue,
  } = props;

  const onEditValueWrapper = useCallback(
    (event: SyntheticEvent<HTMLInputElement>) => {
      onEditValue(fieldId, (event.target as HTMLInputElement)!.value);
    },
    [fieldId, onEditValue],
  );

  const onRemoveFieldWrapper = useCallback(() => {
    onRemoveField(fieldId);
  }, [fieldId, onRemoveField]);

  const onEditKeyWrapper = useCallback(
    (text: string) => {
      onEditKey?.(fieldId, text);
    },
    [fieldId, onEditKey],
  );

  // ▼ ▶︎
  return (
    <tr>
      <td>
        {onEditKey
          ? (
            <EditableText
              // onFocus={onFocusId}
              toggleEdit={true}
              value={fieldId}
              write={onEditKeyWrapper}
            />
          )
          : fieldId}
      </td>

      <td>
        <input
          type="text"
          value={fieldValue}
          onInput={onEditValueWrapper}
          // onBlur={getCallback(field)}
          className={`noticeable`}
        />
      </td>
      <td>
        {/* <button className="close-btn" onClick={onRemoveFieldWrapper}>
          -
        </button> */}
      </td>
    </tr>
  );
}
